import { render, staticRenderFns } from "./fixedInvitation.vue?vue&type=template&id=8bd786fe&"
import script from "./fixedInvitation.vue?vue&type=script&lang=js&"
export * from "./fixedInvitation.vue?vue&type=script&lang=js&"
import style0 from "./fixedInvitation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports